import React from "react";
import Layout from "@/Layout";
// import QRCode from 'qrcode-react';
import { get, post } from "$ACTIONS/TlcRequest";
import { ApiPort } from "$ACTIONS/TLCAPI";
import RealNameVerify from "@/Verification/RealNameVerify";
import PhoneVerify from "@/Verification/PhoneVerify";
import { numberformatter } from "$ACTIONS/util";
import { Button, Empty, Icon, Spin, message } from "antd";
import { CopyToClipboard } from "react-copy-to-clipboard";
import QRCode from "qrcode-react";
import moment from "moment";
import { getStaticPropsFromStrapiSEOSetting } from "$DATA/seo";
import { connect } from "react-redux";
import { getMemberInfoAction } from "$STORE/thunk/memberThunk";
import { isGuest } from "$ACTIONS/helper";
import { allSettled } from "$DATA/js/util";

export async function getStaticProps() {
    return await getStaticPropsFromStrapiSEOSetting("/referrer-activity"); //參數帶本頁的路徑
}

class RAF extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneVisible: false,
            realnameVisible: false,
            phoneattemptRemaining: 5,
            isNext: false, // 是否是真名以及手机号未验证
            applyStep: 1,
            referUrl: "",
            totalDeposits: 0, // 会员已存款金额
            totalBets: 0,
            referreeList: [], // 被推薦人清單
            hideReferreeList: true, // true: 顯示3筆, false: 顯示全部
            totalDepositRequired: 0, // 需要满足的最低存款金额
            totalBetAmountRequired: 0, // 需要满足的最低流水要求
            campaignRewardDetails: [],
            isLoading: false,
            // referPromptInfo: "",
            startDate: "", // 活动开始时间
            isDepositMet: false,
            isBetAmountMet: false,
            isRegisteredMet: false,
            isVerificationMet: false,
        };

        this.addActive = this.addActive.bind(this);
        this.correctMemberInfo = this.correctMemberInfo.bind(this); // 更正会员信息
        this.ReferrerSignUp = this.ReferrerSignUp.bind(this);
        this.GetQueleaActiveCampaign = this.GetQueleaActiveCampaign.bind(this);
        this.ReferreeList = this.ReferreeList.bind(this); // 獲取被推薦人清單
        this.referrerEligible = this.referrerEligible.bind(this); // 获取会员是否满足条件的详情
        this.ReferrerActivity = this.ReferrerActivity.bind(this); // 获取用户已存款金额、驗證狀態
        this.checkMemberInfo = this.checkMemberInfo.bind(this); // 检查用户是否已经加入活动，以及获取用户信息
        this.goVerified = this.goVerified.bind(this); // 立即进行真名与手机号验证流程
        // this.autoClearPrompt = this.autoClearPrompt.bind(this);
        this.downloadCanvas = this.downloadCanvas.bind(this);
        this.VerifyCategory = this.VerifyCategory.bind(this);
        this.chageStatus = this.chageStatus.bind(this); //清單狀態轉換文字
        this.qrcodeDOM = React.createRef();

        // this.promptTimer = null;
    }
    componentDidMount() {
        let promiseArr = [];
        // 查询活动信息
        promiseArr.push(this.GetQueleaActiveCampaign());

        const isLogin = !isGuest();
        if(isLogin) {
            // 获取用户已存款金额、驗證狀態
            promiseArr.push(this.ReferrerActivity());
            // 检查用户是否已经加入活动，以及获取用户信息
            promiseArr.push(this.checkMemberInfo());
            // 获取用户参与活动条件的详情
            promiseArr.push(this.referrerEligible());
            // 獲取被推薦人清單
            promiseArr.push(this.ReferreeList());
        }

        this.setState({ isLoading: true });
        allSettled(promiseArr).then((res) => {
            console.log("fetch Raf content", res);
        }).catch((err) => {
            console.error("fetch error", err);
        }).finally(() => {
            this.setState({ isLoading: false });
        })
    }
    componentDidUpdate(prevProps, prevState) {
        if (
            prevProps.memberInfo?.registerDate !==
                this.props.memberInfo?.registerDate &&
            this.props.memberInfo?.registerDate
        ) {
            this.setState({ isLoading: true });
            // 获取用户已存款金额、驗證狀態、检查用户是否已经加入活动，以及获取用户信息、获取用户参与活动条件的详情、獲取被推薦人清單
            allSettled([this.ReferrerActivity(), this.checkMemberInfo(), this.referrerEligible(), this.ReferreeList()]).then((res) => {
                console.log("fetch Raf content", res);
            }).catch((err) => {
                console.error("fetch error", err);
            }).finally(() => {
                this.setState({ isLoading: false });
            });
        }
    }
    componentWillUnmount() {
        // clearTimeout(this.promptTimer);
    }
    addActive() {
        this.setState({ isLoading: true });
        get(ApiPort.GetQueleaActiveCampaign).then((data) => {
            this.setState({ isLoading: false });
            if (data && data.isSuccess) {
                if (!localStorage.getItem("access_token")) {
                    global.goUserSign("1");
                } else if (JSON.stringify(this.props.memberInfo) !== "{}") {
                    this.setState({ applyStep: 2 });
                }
            } else {
                message.info("即将开启，敬请期待！");
            }
        });
    }
    // 查询活动信息
    GetQueleaActiveCampaign() {
        return get(ApiPort.GetQueleaActiveCampaign).then((data) => {
            data &&
                data.result &&
                this.setState({
                    campaignRewardDetails: data.result.campaignRewardDetails,
                    totalDepositRequired:
                        data.result.campaignSignUpPreCondition
                            ?.totalDepositRequired,
                    totalBetAmountRequired:
                        data.result.campaignSignUpPreCondition
                            ?.totalBetAmountRequired,
                    startDate: data.result.startDate
                        ? moment(data.result.startDate).format("DD/MM/YYYY")
                        : "",
                });
        });
    }
    ReferrerActivity() {
        return get(ApiPort.ReferrerActivity).then((data) => {
            if (data && data.isSuccess && data.result) {
                let totalDeposits, totalBets, phoneVerified, realNameVerified;
                if (Array.isArray(data.result)) { // BFF
                    if (data.result.length) {
                        totalDeposits = data.result[0].totalDeposits;
                        totalBets = data.result[0].totalBets;
                        phoneVerified = data.result[0].phoneVerified;
                        realNameVerified = data.result[0].realNameVerified;
                    }
                } else { // BFFSC
                    if (data.result) {
                        totalDeposits = data.result.totalDeposits;
                        totalBets = data.result.totalBets;
                        phoneVerified = data.result.phoneVerified;
                        realNameVerified = data.result.realNameVerified;
                    }
                }
                this.setState({
                    totalDeposits,
                    totalBets,
                    phoneVerified,
                    realNameVerified
                });
            }
        });
    }
    checkMemberInfo() {
        return get(ApiPort.GetQueleaInfo).then((data) => {
            if (data && data.isSuccess && data.result) {
                if (!data.result.referrerID && !data.result.campaignName) {
                    this.setState({ applyStep: 1 }); // 显示立即加入按钮
                } else {
                    // 显示分享链接以及二维码
                    this.setState({
                        applyStep: 3,
                        referUrl: data.result.queleaUrl,
                        referCode: data.result.referrerID,
                    });
                }
            }
        });
    }
    correctMemberInfo() {
        this.props.getMemberInfo((res) => {}, true);
        this.referrerEligible();
        this.ReferrerActivity();
    }
    // 注册活动，获取连接
    ReferrerSignUp() {
        this.setState({ isLoading: true });
        post(ApiPort.ReferrerSignUp).then((data) => {
            if (data?.isSuccess && data?.result) {
                this.setState({
                    applyStep: 3,
                    isLoading: false,
                    referUrl: data.result.queleaUrl,
                    referCode: data.result.referrerID,
                });
            }
            this.setState({ isLoading: false });
        });
    }
    downloadCanvas() {
        let save_link = document.createElementNS(
            "http://www.w3.org/1999/xhtml",
            "a"
        );
        save_link.href =
            this.qrcodeDOM.current.refs.canvas.toDataURL("image/png");
        save_link.download = "tlc_app_qrcode.png";

        let event = document.createEvent("MouseEvents");
        event.initMouseEvent(
            "click",
            true,
            false,
            window,
            0,
            0,
            0,
            0,
            0,
            false,
            false,
            false,
            false,
            0,
            null
        );
        save_link.dispatchEvent(event);

        // this.autoClearPrompt("已保存");
        message.success("บันทึกสำเร็จ"); //保存成功
    }
    // autoClearPrompt(text) {
    //     this.setState({ referPromptInfo: text });
    //     this.promptTimer = setTimeout(() => {
    //         this.setState({ referPromptInfo: "" });
    //     }, 3000);
    // }
    goVerified() {
        const { phoneVerified, realNameVerified } = this.state;
        switch (true) {
            case !phoneVerified && !realNameVerified:
                this.setState({ realnameVisible: true, isNext: true });
                break;
            case !realNameVerified:
                this.setState({ realnameVisible: true });
                break;
            case !phoneVerified:
                this.setState({ phoneVisible: true });
                break;
            default:
                break;
        }
    }
    // 获取用户是否满足申请条件
    referrerEligible() {
        return get(ApiPort.ReferrerEligible).then((data) => {
            if (data && data.isSuccess && data.result) {
                this.setState({
                    isDepositMet: data.result.isDepositMet,
                    isBetAmountMet: data.result.isBetAmountMet,
                    isRegisteredMet: data.result.isRegisteredMet,
                    isVerificationMet: data.result.isVerificationMet,
                });
            }
        });
    }
    // 获取被推荐人清單
    ReferreeList() {
        return get(ApiPort.ReferreeList).then((res) => {
            if (res && res.isSuccess && res.result) {
                this.setState({
                    referreeList: res.result.refereeDetails || res.result.referreeDetails, // means BFFSC || BFF
                });
            } else {
                this.setState({
                    referreeList: [],
                });
            }
        });
    }

    VerifyCategory(otpVisible, emailVisible, phoneVisible) {
        this.setState({
            phoneVisible: phoneVisible,
        });
    }

    chageStatus(referrerPayoutStatus) {
        switch (referrerPayoutStatus) {
            // 處理中
            case 1:
            case 3:
            case 4:
                return { text: "กำลังดำเนินการ", color: "#F0A800" };
            // 成功
            case 2:
                return { text: "สำเร็จ", color: "#0CCC3C" };
            // 失敗
            case 5:
                return { text: "ไม่สำเร็จ", color: "#EB2121" };
            default:
                return {};
        }
    }

    getFormattedValue = (value, fallback = "N/A") => {
        return value != null ? numberformatter(value, 0, true) : fallback;
    };

    // 用來處理 rewardA 和 rewardB，相加並處理 null 或 undefined 的情況
    getTotalReward = (rewardA, rewardB, fallback = "N/A") => {
        if (rewardA == null && rewardB == null) {
            return fallback; // 如果兩者都是 null 或 undefined，顯示 N/A
        }
        
        // 將 null 或 undefined 視為 0，進行加總
        const total = (rewardA != null ? rewardA : 0) + (rewardB != null ? rewardB : 0);
        return numberformatter(total, 0, true); // 格式化並返回總和
    };

    render() {
        const {
            isDepositMet,
            isBetAmountMet,
            isRegisteredMet,
            isVerificationMet,
            referreeList,
            hideReferreeList,
            phoneVerified,
            realNameVerified,
            campaignRewardDetails,
        } = this.state;
        const { memberInfo } = this.props;
        console.log(this.state.applyStep + "---------" + this.state.referUrl);
        return (
            <Layout seoData={this.props.seoData} showFooter={false} status={1}>
                <div className="common-distance-wrap">
                    <Spin size="large" spinning={this.state.isLoading}>
                        <div className="common-distance">
                            <div className="im-wrap">
                                <div className="invite-friend-banner">
                                    {/* <p> 们请注意</p>
									<h2>每邀请一位好友</h2>
									<h2>可享96元彩金</h2> */}
                                </div>
                                <div className="invite-friend-content">
                                    <div className="invite-step-wrap">
                                        {this.state.applyStep === 1 &&
                                        !this.state.referUrl ? (
                                            <React.Fragment>
                                                <h4 className="invite-title">
                                                    วิธีเข้าร่วม
                                                    {/* 推荐好友三步骤 */}
                                                </h4>
                                                <ul className="invite-list-step">
                                                    <li>
                                                        <div className="invite-step-number">
                                                            1
                                                        </div>
                                                        <div className="invite-step-content">
                                                            <h4>
                                                                คลิกปุ่ม
                                                                “เข้าร่วม”
                                                                {/* 点击 “立即加入” 按钮 */}
                                                            </h4>
                                                            <p>
                                                                กดรับลิงก์หรือแชร์ให้เพื่อนสมัคร
                                                                {/* 满足指定条件，生成推荐链接。 */}
                                                            </p>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div className="invite-step-number">
                                                            2
                                                        </div>
                                                        <div className="invite-step-content">
                                                            <h4>
                                                                แชร์ลิงก์แนะนำ
                                                                หรือ QR Code
                                                                แนะนำเพื่อน
                                                                {/* 分享推荐链接或二维码 */}
                                                            </h4>
                                                            <p>
                                                                เพื่อนที่แนะนำจะต้องลงทะเบียนและเล่นเกมผ่านลิงก์
                                                                {/* 被推荐的好友须透过链接注册并进行游戏。 */}
                                                            </p>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div className="invite-step-number">
                                                            3
                                                        </div>
                                                        <div className="invite-step-content">
                                                            <h4>
                                                                ตรวจสอบการแนะนำเพื่อนและรอรับโบนัส
                                                                {/* 查看进度及获得彩金 */}
                                                            </h4>
                                                            <p>
                                                                สามารถไปที่หน้า
                                                                “สถานะการแนะนำ”
                                                                <br />
                                                                เพื่อดูสถานะการแนะนำเพื่อนของคุณได้ตลอดเวลา
                                                                {/* 可随时前往
                                                                “推荐好友”
                                                                页面查看好友们的注册、充值、流水进度。 */}
                                                            </p>
                                                        </div>
                                                    </li>
                                                </ul>
                                                <Button
                                                    size="large"
                                                    type="primary"
                                                    onClick={this.addActive}
                                                    block
                                                >
                                                    เข้าร่วม
                                                    {/* 立即加入 */}
                                                </Button>
                                            </React.Fragment>
                                        ) : this.state.applyStep === 3 &&
                                          this.state.referUrl ? (
                                            <div className="refer-qrcode-wrap">
                                                {/* {!!this.state
                                                    .referPromptInfo ? (
                                                    <div
                                                        className={`prompt-center-box refer-friend-prompt${
                                                            this.state
                                                                .referPromptInfo ===
                                                            "已保存"
                                                                ? " _2"
                                                                : ""
                                                        }`}
                                                    >
                                                        {
                                                            this.state
                                                                .referPromptInfo
                                                        }
                                                    </div>
                                                ) : null} */}
                                                <p>
                                                    แนะนำ
                                                    {/* 分享链接 */}
                                                </p>
                                                <p className="refer-link-title">
                                                    ลิงก์สำหรับแชร์แนะนำเพื่อน
                                                </p>
                                                <div
                                                    className="refer-href-link margin-distance black-color"
                                                    title={this.state.referUrl}
                                                >
                                                    {this.state.referUrl}
                                                </div>
                                                <CopyToClipboard
                                                    text={this.state.referUrl}
                                                    onCopy={() => {
                                                        // this.autoClearPrompt(
                                                        //     "已复制"
                                                        // );
                                                        message.success(
                                                            "คัดลอกสำเร็จ"
                                                        ); //复制成功！
                                                    }}
                                                >
                                                    <Button
                                                        className="margin-distance"
                                                        type="primary"
                                                        size="large"
                                                        block
                                                        ghost
                                                    >
                                                        คัดลอกลิงก์แนะนำ
                                                        {/* 复制链接 */}
                                                    </Button>
                                                </CopyToClipboard>
                                                <p className="refer-qrcode-title">
                                                    QR Code
                                                    สำหรับแชร์แนะนำเพื่อน
                                                    {/* 推荐二维码 */}
                                                </p>
                                                <div className="margin-distance center">
                                                    <QRCode
                                                        size={120}
                                                        value={
                                                            this.state.referUrl
                                                        }
                                                        ref={this.qrcodeDOM}
                                                    />
                                                </div>
                                                <Button
                                                    className="refer-qrcode-btn"
                                                    type="primary"
                                                    size="large"
                                                    block
                                                    onClick={
                                                        this.downloadCanvas
                                                    }
                                                >
                                                    บันทึก QR CODE
                                                    {/* 保存二维码 */}
                                                </Button>
                                                <p className="fail-color">
                                                    กดแชร์ลิงก์หรือรหัส QR
                                                    นี้กับเพื่อนของคุณ
                                                    ผู้ถูกแนะนำจะต้อง
                                                    ลงทะเบียนจากลิ้งก์ที่กำหนดนี้
                                                    และสามารถตรวจสอบโบนัสได้ที่
                                                    สถานะการแนะนำ
                                                    {/* 将此链接或二维码分享给好友，被推荐人透过此网址进行注册并游戏，推荐人即可在“奖金进度”中查看彩金的状况。 */}
                                                </p>
                                            </div>
                                        ) : (
                                            <React.Fragment>
                                                <h4 className="invite-title">
                                                    วิธีเข้าร่วม
                                                    {/* 须满足申请资格 */}
                                                </h4>
                                                <ul className="invite-list-step has-login">
                                                    <li>
                                                        <div className="invite-step-number">
                                                            1
                                                        </div>
                                                        <div className="invite-step-content">
                                                            <h4>
                                                                {`ยอดฝาก ${numberformatter(
                                                                    this.state
                                                                        .totalDepositRequired,
                                                                    0
                                                                )} บาท`}
                                                                {/* 总存款金额满 X 泰銖 */}
                                                            </h4>
                                                            <p>
                                                                <i
                                                                    className={`tlc-sprite user-deposit-currency${
                                                                        isDepositMet
                                                                            ? " curr"
                                                                            : ""
                                                                    }`}
                                                                />
                                                                <span>
                                                                    {`(${this.state.totalDeposits} 
                                                                    / 
                                                                    ${this.state.totalDepositRequired})`}
                                                                </span>
                                                            </p>
                                                            {isDepositMet ? null : (
                                                                <Button
                                                                    type="danger"
                                                                    onClick={() => {
                                                                        global.showDialog(
                                                                            {
                                                                                key: 'wallet:{"type": "deposit"}',
                                                                            }
                                                                        );
                                                                    }}
                                                                    disabled={
                                                                        false
                                                                    }
                                                                >
                                                                    ฝากเงิน
                                                                    {/* 马上存款 */}
                                                                </Button>
                                                            )}
                                                        </div>
                                                        {isDepositMet ? (
                                                            <Icon
                                                                type="check-circle"
                                                                theme="filled"
                                                                className="success"
                                                            />
                                                        ) : (
                                                            <Icon type="check-circle" />
                                                        )}
                                                    </li>
                                                    <li>
                                                        <div className="invite-step-number">
                                                            2
                                                        </div>
                                                        <div className="invite-step-content">
                                                            <h4>
                                                                {`ยอดหมุนเวียน ${numberformatter(
                                                                    this.state
                                                                        .totalBetAmountRequired,
                                                                    0
                                                                )} บาท`}
                                                                {/* 达 X 流水 */}
                                                            </h4>
                                                            <p>
                                                                <i
                                                                    className={`tlc-sprite user-bonus-currency${
                                                                        isBetAmountMet
                                                                            ? " curr"
                                                                            : ""
                                                                    }`}
                                                                />
                                                                <span>
                                                                    {`(${this.state.totalBets} 
                                                                    / 
                                                                    ${this.state.totalBetAmountRequired})`}
                                                                </span>
                                                            </p>
                                                        </div>
                                                        {isBetAmountMet ? (
                                                            <Icon
                                                                type="check-circle"
                                                                theme="filled"
                                                                className="success"
                                                            />
                                                        ) : (
                                                            <Icon type="check-circle" />
                                                        )}
                                                    </li>
                                                    <li>
                                                        <div className="invite-step-number">
                                                            3
                                                        </div>
                                                        <div className="invite-step-content">
                                                            <h4>
                                                                ยืนยันชื่อจริง &
                                                                เบอร์โทร
                                                                {/* 验证真名和手机 */}
                                                            </h4>
                                                            <p>
                                                                <i
                                                                    className={`tlc-sprite user-profile ${
                                                                        realNameVerified &&
                                                                        "curr"
                                                                    }`}
                                                                />
                                                                <span>
                                                                    {realNameVerified
                                                                        ? "ยืนยันเรียบร้อย"
                                                                        : "ยังไม่ได้รับการยืนยัน"}
                                                                    {/* 已验证/未验证 */}
                                                                </span>
                                                                <i
                                                                    className={`tlc-sprite user-phone ${
                                                                        phoneVerified &&
                                                                        "curr"
                                                                    }`}
                                                                />
                                                                <span>
                                                                    {phoneVerified
                                                                        ? "ยืนยันเรียบร้อย"
                                                                        : "ยังไม่ได้รับการยืนยัน"}
                                                                    {/* 已验证/未验证 */}
                                                                </span>
                                                            </p>
                                                            {isVerificationMet ? null : (
                                                                <Button
                                                                    style={{
                                                                        marginLeft:
                                                                            realNameVerified
                                                                                ? "103px"
                                                                                : "0px",
                                                                    }}
                                                                    type="danger"
                                                                    onClick={
                                                                        this
                                                                            .goVerified
                                                                    }
                                                                    disabled={
                                                                        false
                                                                    }
                                                                >
                                                                    ยืนยัน
                                                                    {/* 进行验证 */}
                                                                </Button>
                                                            )}
                                                        </div>
                                                        {isVerificationMet ? (
                                                            <Icon
                                                                type="check-circle"
                                                                theme="filled"
                                                                className="success"
                                                            />
                                                        ) : (
                                                            <Icon type="check-circle" />
                                                        )}
                                                    </li>
                                                </ul>
                                                <Button
                                                    type="danger"
                                                    size="large"
                                                    disabled={
                                                        !(
                                                            isDepositMet &&
                                                            isBetAmountMet &&
                                                            isVerificationMet
                                                        )
                                                    }
                                                    onClick={
                                                        this.ReferrerSignUp
                                                    }
                                                    block
                                                >
                                                    กดรับลิ้งก์แนะนำเพื่อน
                                                    {/* 生成专属推荐链接 */}
                                                </Button>
                                            </React.Fragment>
                                        )}
                                        {this.state.applyStep !== 3 && (
                                            <p className="fail-color center">
                                                อัพเดทล่าสุด:
                                                {this.state.startDate}
                                                {/* 活动开始时间： */}
                                            </p>
                                        )}
                                    </div>
                                    <div className="invite-prize-wrap">
                                        {this.state.applyStep === 2 ||
                                        this.state.applyStep === 3 ? (
                                            <React.Fragment>
                                                <h4 className="invite-title">
                                                    เพื่อนที่แนะนำ
                                                    {/* 推荐的朋友 */}
                                                </h4>
                                                <ul>
                                                    {referreeList?.length ===
                                                        0 && (
                                                        <li className="fail-color">
                                                            <Empty
                                                                image={
                                                                    "/th/img/img-no-record.svg"
                                                                }
                                                                imageStyle={{
                                                                    height: "68px",
                                                                }}
                                                                description="ไม่พบข้อมูล" //暂无记录
                                                            />
                                                        </li>
                                                    )}
                                                    {referreeList?.length > 0 &&
                                                        referreeList
                                                            .slice(
                                                                0,
                                                                hideReferreeList
                                                                    ? 3
                                                                    : referreeList.length
                                                            )
                                                            .map(
                                                                (
                                                                    referree,
                                                                    index
                                                                ) => {
                                                                    return (
                                                                        <li key={`referee_${index}`} className="prize-referee-list">
                                                                            <div>
                                                                                <img
                                                                                    className="referee-label"
                                                                                    src="/th/img/raf/label.svg"
                                                                                />
                                                                                <span className="referee-number">
                                                                                    {index +
                                                                                        1}
                                                                                </span>
                                                                            </div>
                                                                            <div className="referree-detail-box">
                                                                                <div className="referree-user-image" />
                                                                                <div className="referree-detail-list">
                                                                                    <label>
                                                                                        วันที่สมัคร
                                                                                    </label>
                                                                                    {/* 註冊日期 */}
                                                                                    <p>
                                                                                        {moment(
                                                                                            referree?.dateRegister
                                                                                        ).format(
                                                                                            "DD-MM-YYYY"
                                                                                        )}
                                                                                    </p>
                                                                                    <label>
                                                                                        หมายเลขธุรกรรม
                                                                                    </label>
                                                                                    {/* 交易代號 */}
                                                                                    <p>
                                                                                        {referree
                                                                                            ?.refereeTierDetail
                                                                                            ?.referrerTransactionID ||
                                                                                            "-"}
                                                                                    </p>
                                                                                    <label>
                                                                                        โบนัส
                                                                                    </label>
                                                                                    {/* 獎金 */}
                                                                                    <p>{`฿ ${referree?.refereeTierDetail?.referrerPayoutAmount}`}</p>
                                                                                    <label>
                                                                                        สถานะ
                                                                                    </label>
                                                                                    {/* 狀態 */}
                                                                                    <p
                                                                                        style={{
                                                                                            color: this.chageStatus(
                                                                                                referree
                                                                                                    ?.refereeTierDetail
                                                                                                    ?.referrerPayoutStatus
                                                                                            )
                                                                                                .color,
                                                                                        }}
                                                                                    >
                                                                                        {
                                                                                            this.chageStatus(
                                                                                                referree
                                                                                                    ?.refereeTierDetail
                                                                                                    ?.referrerPayoutStatus
                                                                                            )
                                                                                                .text
                                                                                        }
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </li>
                                                                    );
                                                                }
                                                            )}
                                                </ul>
                                                {referreeList?.length > 3 && (
                                                    <div className="hide-referree-list-btn-box">
                                                        <Button
                                                            className="hide-referree-list-btn"
                                                            type="primary"
                                                            shape="round"
                                                            size="large"
                                                            ghost
                                                            onClick={() =>
                                                                this.setState({
                                                                    hideReferreeList:
                                                                        !hideReferreeList,
                                                                })
                                                            }
                                                        >
                                                            <span>
                                                                {`${
                                                                    !hideReferreeList
                                                                        ? "ดูเพิ่มเติม" //查看更多
                                                                        : "ดูเพิ่มเติม"
                                                                }`}
                                                            </span>
                                                            <img src="/th/img/raf/dropdown.svg" />
                                                        </Button>
                                                    </div>
                                                )}
                                            </React.Fragment>
                                        ) : null}
                                        {this.state.applyStep === 1 &&
                                        campaignRewardDetails?.length ? (
                                            <React.Fragment>
                                                <h4 className="invite-title">
                                                    เงื่อนไขโปรโมชั่น
                                                    {/* 推荐奖金 */}
                                                </h4>
                                                <table className="invite-list-table">
                                                    <thead>
                                                        <tr className="head">
                                                            <th colSpan="2">
                                                                ผู้ถูกแนะนำ
                                                                {/* 被推薦人 */}
                                                            </th>
                                                            <th>
                                                                ผู้ถูกแนะนำ
                                                                {/* 被推薦人 */}
                                                            </th>
                                                            <th>ผู้แนะนำ</th>
                                                            {/* 推薦人 */}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                ฝากสะสม
                                                            </td>
                                                            <td>
                                                                ยอดหมุนเวียน
                                                            </td>
                                                            <td>
                                                                จำนวนโบนัส
                                                            </td>
                                                            <td>
                                                                จำนวนโบนัส
                                                            </td>
                                                        </tr>
                                                        {campaignRewardDetails.map(
                                                            (v, index) => {
                                                                return (
                                                                    <tr
                                                                        key={
                                                                            index
                                                                        }
                                                                    >
                                                                        <td>
                                                                            {this.getFormattedValue(v.depositAmount)}
                                                                        </td>
                                                                        <td>
                                                                            {this.getFormattedValue(v.turnoverAmount)}
                                                                        </td>
                                                                        <td className="theme-color">
                                                                            {this.getFormattedValue(v.refereeRewardAmount)}
                                                                        </td>
                                                                        <td className="theme-color">
                                                                            {this.getFormattedValue(v.referralRewardAmount)}
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            }
                                                        )}
                                                    </tbody>
                                                </table>
                                            </React.Fragment>
                                        ) : null}
                                        <div className="prize-example-wrap">
                                            <p>ตัวอย่าง: A แนะนำ B</p>
                                            {/* 范例：A 推荐 B */}
                                            <p
                                                data-CN="推荐人存入最低 100 泰铢并累计营业额 300 泰铢 >> 每人可获得 28 泰铢的奖金。"
                                                className="prize-example-list"
                                            >
                                                - B สมัครสำเร็จ มียอดฝากสะสมอย่างน้อย {this.getFormattedValue(campaignRewardDetails?.[1]?.depositAmount)} บาท และมียอดหมุนเวียน<br />
                                                {this.getFormattedValue(campaignRewardDetails?.[1]?.turnoverAmount)} บาท ดังนั้น A และ B จะได้รับโบนัสฟรีทั้งหมด{" "}
                                                {this.getTotalReward(campaignRewardDetails?.[0]?.referralRewardAmount, campaignRewardDetails?.[1]?.referralRewardAmount)} บาท<br/>
                                                โดยมาจากยอด {this.getFormattedValue(campaignRewardDetails?.[0]?.referralRewardAmount)} + {" "}
                                                {this.getFormattedValue(campaignRewardDetails?.[1]?.referralRewardAmount)}  บาท
                                            </p>
                                            <p
                                                data-CN="推荐人存入最低 1,000 泰铢并累积营业额 3,000 泰铢 >> 每人可获得 88 泰铢的奖金。"
                                                className="prize-example-list"
                                            >
                                                - ถ้า B มียอดฝากสะสมมากว่า {this.getFormattedValue(campaignRewardDetails?.[0]?.depositAmount)} บาท
                                                แต่น้อยกว่า {this.getFormattedValue(campaignRewardDetails?.[1]?.depositAmount)} บาท<br/>
                                                และมียอดหมุนเวียน {this.getFormattedValue(campaignRewardDetails?.[0]?.turnoverAmount)} บาท
                                                สมาชิก A และ B จะได้รับโบนัสฟรี {this.getFormattedValue(campaignRewardDetails?.[0]?.referralRewardAmount)} บาท
                                            </p>
                                        </div>
                                        <div className="prize-example-wrap">
                                            <p>เพิ่มเติม</p>
                                            {/* 备注： */}
                                            <ul className="decimal-list">
                                                <li>
                                                    ผู้แนะนำและผู้ถูกแนะนำจะได้รับโบนัสหลังจากที่ผู้ถูกแนะนำฝากเงินและ<br/>{" "}
                                                    มียอดหมุนเวียนครบตามที่กำหนด ภายในระยะเวลากิจกรรมเท่านั้น<br/>{" "}
                                                    (ผู้แนะนำสามารถรับโบนัส {this.getFormattedValue(campaignRewardDetails?.[0]?.referralRewardAmount)} บาท และ
                                                    {this.getFormattedValue(campaignRewardDetails?.[1]?.referralRewardAmount)} บาทพร้อมกันได้)
                                                </li>
                                                <li>
                                                    ผู้แนะนำจะต้องมีเงินฝากอย่างน้อยหนึ่งครั้งจึงจะมีคุณสมบัติตาม<br/>{" "}
                                                    แคมเปญนี้
                                                </li>
                                                <li>ผู้แนะนำจะต้องยืนยันชื่อและหมายเลขโทรศัพท์ของตนให้ครบถ้วน</li>
                                                <li>ผู้แนะนำสามารถทำการแนะนำได้สูงสุด 20 คน ต่อเดือน</li>
                                            </ul>
                                        </div>
                                        <h4 className="invite-title">
                                            คำถามที่พบบ่อย
                                            {/* 常见问题 */}
                                        </h4>
                                        <div className="invite-question">
                                            <ul className="question-list">
                                                <li>
                                                    <div className="black-color">
                                                        <b>
                                                            Q :
                                                            สามารถใช้โบนัสนี้ร่วมกับโปรโมชั่นอื่นๆ
                                                            ได้หรือไม่
                                                            {/* Q：彩金是否可以申请其他优惠？ */}
                                                        </b>
                                                    </div>
                                                    <div>
                                                        A :
                                                        โบนัสนี้ไม่สามารถใช้ร่วมกับโปรโมชั่นอื่นๆ
                                                        ได้
                                                        {/* A：此优惠所派发的彩金是可以申请官网其他优惠。​ */}
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="black-color">
                                                        <b>
                                                            Q :
                                                            ต้องทำยอดเทิร์นเท่าไหร่ก่อนการถอน
                                                            {/* Q：所获得的彩金需要多少流水才可以提款？ */}
                                                        </b>
                                                    </div>
                                                    <div>
                                                        A : โบนัสมียอดเทิร์น 1
                                                        เท่าก่อนการถอน
                                                        {/* A：此优惠所派发的彩金只需一倍流水即可提款。 */}
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="black-color">
                                                        <b>
                                                            Q :
                                                            หากไม่สามารถยืนยันเบอร์โทรและอีเมลได้
                                                            {/* Q：无法验证手机号以及邮箱账号？ */}
                                                        </b>
                                                    </div>
                                                    <div>
                                                        A : ติดต่อ{" "}
                                                        <Button
                                                            type="link"
                                                            className="inline"
                                                            style={{
                                                                color: "#00A6FF",
                                                            }}
                                                            onClick={() =>
                                                                global.PopUpLiveChat()
                                                            }
                                                        >
                                                            นางฟ้า Fun Angel
                                                        </Button>{" "}
                                                        เพื่อให้ความช่วยเหลือได้ทันที
                                                        {/* A：联系官网24小时在线客服进行辅助验证。 */}
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                        <h4 className="invite-title">
                                            ข้อกำหนดและเงื่อนไขโปรโมชั่น
                                            {/* 活动规则 */}
                                        </h4>
                                        <ul className="decimal-list">
                                            <li>
                                                <p>
                                                    ผู้ถูกแนะนำจะต้องลงทะเบียนและเล่นที่เว็บไซต์นี้เป็นครั้งแรก
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    ผู้ถูกแนะนำจะต้องลงทะเบียนด้วยที่อยู่ IP ที่แตกต่างจากผู้แนะนำ<br />{" "}
                                                    และต้องไม่อาศัยอยู่ที่เดียวกัน
                                                </p>
                                            </li>
                                            <li>
                                                <p>                                                 
                                                    ผู้ถูกแนะนำจะต้องลงทะเบียนผ่านลิงก์ผู้แนะนำ ของคุณหรือรหัส QR<br />{" "}
                                                    ผู้แนะนำเพื่อเป็นสมาชิก
                                                </p>
                                            </li>
                                            <li>
                                                <p>                                           
                                                    ผู้ถูกแนะนำจะต้องตรวจสอบความถูกต้องของหมายเลขโทรศัพท์<br />{" "}
                                                    ให้ครบถ้วน
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    เฉพาะสมาชิกที่กรอกหมายเลขโทรศัพท์ที่ถูกต้องเท่านั้นจึงจะมีสิทธิ์<br />{" "}
                                                    ได้รับรางวัลสมาชิกสามารถติดต่อฝ่ายบริการลูกค้าบนเว็บไซต์<br />{" "}
                                                    อย่างเป็นทางการเพื่อทำการเปลี่ยนแปลง
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    พฤติกรรมการเดิมพันที่ผิดปกติใดๆ เมื่อถูกค้นพบเจอแล้ว<br />{" "}
                                                    จะทำให้ผู้เข้าร่วมถูกตัดสิทธิ์จากโปรโมชั่นนี้ทันที
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    ข้อเสนอโปรโมชั่นนี้ใช้ได้กับผู้เล่นที่มีเพียงบัญชีเดียวเท่านั้น<br />{" "}
                                                    ที่อยู่ ที่อยู่อีเมล หมายเลขโทรศัพท์ วิธีการชำระเงิน<br />{" "}
                                                    (บัตรเดบิต/บัตรเครดิต/หมายเลขบัญชีธนาคารเดียวกัน) ที่อยู่ IP<br />{" "}
                                                    และสภาพแวดล้อมเครือข่ายเดียวกันสามารถใช้เป็นเกณฑ์<br />{" "}
                                                    ในการพิจารณาว่าผู้เล่นมีความเกี่ยวข้องกันหรือไม่
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    กำหนดเวลาสำหรับกิจกรรมจะได้รับแจ้งจากเว็บไซต์อย่างเป็นทางการ
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    เว็บไซต์ขอสงวนสิทธิ์ในการตีความในขั้นสุดท้าย และกิจกรรมนี้จะต้อง<br />{" "}
                                                    เป็นไป ตามข้อกำหนดมาตรฐานของเว็บไซต์
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    หากไม่ได้รับโบนัสแนะนำเพื่อนภายใน 24 ชม. หลังทำตามเงื่อนไขครบแล้ว<br />{" "}
                                                    โปรดติดต่อทีมงานนางฟ้า Fun Angel เพื่อติดตามผล
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    สมาชิกที่อยู่ภายใต้พันธมิตร Fun88 ไม่มีสิทธิ์ได้รับโปรโมชั่นนี้
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Spin>
                </div>
                <React.Fragment>
                    {this.state.realnameVisible && (
                        <RealNameVerify
                            visible={this.state.realnameVisible}
                            closeModal={() =>
                                this.setState({ realnameVisible: false })
                            }
                            correctMemberInfo={this.correctMemberInfo}
                            isNext={this.state.isNext}
                            nextStep={() => {
                                this.setState({ phoneVisible: true });
                            }}
                            triggerFrom={"raf"}
                        />
                    )}
                    {this.state.phoneVisible && (
                        <PhoneVerify
                            GetThroughoutVerification={() => {
                                global.GetThroughoutVerification();
                            }}
                            memberInfo={memberInfo}
                            visible={this.state.phoneVisible}
                            closeModal={() =>
                                this.setState({ phoneVisible: false })
                            }
                            correctMemberInfo={this.correctMemberInfo}
                            changeVerify={this.VerifyCategory}
                            phone={
                                memberInfo.isVerifiedPhone &&
                                memberInfo.isVerifiedPhone[0]
                            }
                            otpParam={"memberProfile-otp"}
                            kindOfVerifications={"ContactVerification"}
                            phoneattemptRemaining={this.state.phoneattemptRemaining}
                            setPhoneAttemptRemaining={(v) =>
                                this.setState({ phoneattemptRemaining: v })
                            }
                            modalTitle={`ยืนยันข้อมูลเบอร์โทรศัพท์`} //手机验证
                            isAllowChange={true}
                            triggerFrom={"raf"}
                        />
                    )}
                </React.Fragment>
            </Layout>
        );
    }
}

function mapStateToProps(state) {
    return {
        memberInfo: state.userCenter.memberInfo,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getMemberInfo: (callback, refresh) => {
            dispatch(getMemberInfoAction(callback, refresh));
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(RAF);
